import { render } from "./VocationalSettingBoundaries.vue?vue&type=template&id=3164d4cd&scoped=true"
import script from "./VocationalSettingBoundaries.vue?vue&type=script&lang=js"
export * from "./VocationalSettingBoundaries.vue?vue&type=script&lang=js"

import "./VocationalSettingBoundaries.vue?vue&type=style&index=0&id=3164d4cd&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3164d4cd"]])

export default __exports__